import React from "react";
import {
    redirectionWrapper
} from "../../util/commonFunctions";
import ErrorPage from "../shared/ErrorPage";

const TopicHorizontalWideCard = (props) => {
    return (
        <div className="companies-tab-content">
            {props.topics.length == 0 &&
                <ErrorPage
                    imageUrl="/assets/svg/tier-empty-state.svg"
                    errorPageHeading="You’re not following any Topics"
                    errorPageDescription="Add a Topic to your Watchlist to get started."
                    paraUrl=""
                    paraUrlText=""
                    class="tier"
                />
            }
            {props.topics.length > 0 && props.topics.map((item, index) => {
                return (
                    <>
                        <div className="companies-tab-item">
                            <div className="row align-items-center">
                                <div className="col-9 col-md-9">
                                    <div className="companies-info">
                                        <div className="companies-title">
                                            <h3
                                                onClick={event => {
                                                    redirectionWrapper(
                                                        'topic',
                                                        event,
                                                        item.id,
                                                        item.name,
                                                        props.parentProps,
                                                        props.parentProps.showLoader,
                                                        props.parentProps.hideLoader,
                                                        props.currentLanguage
                                                    )
                                                }}
                                                style={{ cursor: "pointer" }}
                                            >
                                                {item.name}
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-3 col-md-3">
                                    <div className="companies-follow-btns">
                                        <span className={!item.isFollowing ? "nofollow-btn" : "nofollow-btn hide"} onClick={() => props.followObject(item.id, "topic")} >Follow</span>
                                        {props.unFollowObject &&
                                            <span className={item.isFollowing ? "follow-btn gray-follow-btn" : "follow-btn hide"} onClick={() => props.unFollowObject(item.id, "topic")} >Following</span>
                                        }
                                        {!props.unFollowObject &&
                                            <span className={item.isFollowing ? "follow-btn gray-follow-btn disable-unfollow" : "follow-btn hide"} >Following</span>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                );
            })
            }
        </div>
    );
};

export default TopicHorizontalWideCard;
